import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      
      if (!match) {
        navigate('/login');
        return;
      }

      const sessionId = match[1];

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        window.history.replaceState(null, '', '/admin');
        navigate('/admin', { state: { user: response.data }, replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#2A2520] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-[#D4AF37] animate-spin mx-auto mb-4" />
        <p className="text-[#F5F1E8]/70 text-sm tracking-widest uppercase">
          Autenticazione in corso...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
